module.exports = ".error-message {\r\n  text-align: center;\r\n  font-size: 12px;\r\n}\r\n\r\nmat-expansion-panel {\r\n  width: 99.9%;\r\n  max-width: 100%;\r\n}\r\n\r\nth button {\r\n  color: black;\r\n  cursor: pointer;\r\n}\r\n\r\n.action-column {\r\n  width: 40px !important;\r\n  max-width: 40px !important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/calibrations/calibration/calibration.component.css
// module id = ./src/app/calibrations/calibration/calibration.component.css
// module chunks = main